import { render, staticRenderFns } from "./PatternPractice.vue?vue&type=template&id=457d2b85&scoped=true&"
import script from "./PatternPractice.vue?vue&type=script&lang=js&"
export * from "./PatternPractice.vue?vue&type=script&lang=js&"
import style0 from "./PatternPractice.vue?vue&type=style&index=0&id=457d2b85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457d2b85",
  null
  
)

export default component.exports